export default "__VITE_ASSET__kqxN3CDC__"